/**
 * TK — Turkmen. DRAFT, pending the owner's confirmation (CLAUDE.md: "Known open items awaiting
 * him … Turkmen/English translations for category names and unit labels").
 *
 * Deliberately a SUBSET: navigation, statuses and the shared chrome only. Every key absent here
 * falls back to RU (docs/06 §8: `tk → ru`, and RU is guaranteed complete), so a partial bundle
 * degrades to a working Russian screen rather than to a screen full of raw key names.
 *
 * The admin SPA has exactly one user and he works in Russian, so this bundle exists for
 * completeness of the three-locale rule, not because it is on anyone's critical path. Do not
 * pad it with machine translations — a wrong Turkmen string is worse than an honest RU fallback.
 */
export const tk = {
  common: {
    appName: 'MOST — dolandyryş',
    loading: 'Ýüklenýär…',
    save: 'Ýatda sakla',
    cancel: 'Ýatyr',
    close: 'Ýap',
    confirm: 'Tassykla',
    search: 'Gözleg',
    filter: 'Filtr',
    all: 'Ählisi',
    yes: 'Hawa',
    no: 'Ýok',
    copy: 'Göçür',
    copied: 'Göçürildi',
    retry: 'Gaýtala',
    back: 'Yza',
    details: 'Jikme-jik',
    page: 'Sahypa',
    of: '/',
    prev: 'Yza',
    next: 'Öňe',
    total: 'Jemi',
    noRating: 'reýtingsiz',
    unit: {
      piece: 'sany',
      pack: 'gap',
      box: 'guty',
      pallet: 'palet',
      truck: 'ýük ulagy',
    },
    unitShort: {
      piece: 'sany',
      pack: 'gap',
      box: 'guty',
      pallet: 'palet',
      truck: 'ýük ulagy',
    },
  },

  nav: {
    dashboard: 'Panel',
    approvals: 'Tassyklama',
    pricing: 'Baha',
    orders: 'Sargytlar',
    inbox: 'Goldaw çaty',
    users: 'Ulanyjylar',
    categories: 'Kategoriýalar',
    notifications: 'Habarnamalar',
    audit: 'Audit',
    profile: 'Profil',
    language: 'Dil',
    flavor: 'Temanyň reňki',
    theme: 'Açyk / garaňky tema',
    logout: 'Çyk',
  },

  status: {
    order: {
      new: 'Täze',
      in_progress: 'Işde',
      completed: 'Tamamlandy',
      cancelled: 'Ýatyryldy',
    },
    role: {
      buyer: 'Alyjy',
      producer: 'Öndüriji',
      admin: 'Administrator',
    },
  },
  inbox: {
    title: 'Goldaw çaty',
    emptyList: 'Entek hiç kim ýazmady',
    noThread: 'Gepleşigi saýlaň',
    emptyThread: 'Entek habar ýok',
    placeholder: 'Jogap ýazyň…',
    send: 'Ibermek',
    attach: 'Faýl goşmak',
    record: 'Ses habaryny ýazga almak',
    stopRecording: 'Ýazgyny duruzmak',
    loadOlder: 'Öňki habarlary görkezmek',
    today: 'Şu gün',
    yesterday: 'Düýn',
    scrollDown: 'Soňky habarlara geçmek',
    sendError: 'Iberip bolmady. Täzeden synanyşyň.',
    callAudio: 'Audio jaň',
    callVideo: 'Wideo jaň',
    role: { buyer: 'Alyjy', producer: 'Öndüriji' },
    kind: { text: 'Habar', image: 'Surat', video: 'Wideo', audio: 'Audio', file: 'Faýl', call: 'Jaň' },
    call: {
      outgoing: 'Jaň edilýär…',
      incoming: 'Gelýän jaň',
      connecting: 'Baglanyşyk…',
      active: 'Gepleşik dowam edýär',
      endedStatus: 'Jaň tamamlandy',
      accept: 'Jogap bermek',
      decline: 'Ret etmek',
      hangUp: 'Tamamlamak',
      completed: 'Jaň',
      missed: 'Sypdyrylan jaň',
      declined: 'Jaň ret edildi',
      mediaDenied: 'Mikrofona ýa-da kamera rugsat ýok',
      connectionLost: 'Baglanyşyk üzüldi',
      failed: 'Jaňy başladyp bolmady',
    },
  },
} as const;
